import * as types from '../../actionTypes'

export const initialState = {
  activeSkuCode: '',
  all_training_info: [],
  childModuleProgress: { cpu: [], bpu: [] },
  error: null,
  isFetching: false,
  isSavingTraining: false,
  status: null,
  training_report: [],
  training_track: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHING_LMS_TRAINING_STATUSES_CSS:
    case types.UPDATING_LMS_TRAINING_PATH:
    case types.ADD_LMS_TRAINING_PATH:
    case types.FETCHING_LMS_CHILD_MODULE_STATUSES: {
      return {
        ...state,
        error: null,
        isFetching: true,
      }
    }

    case types.FETCHING_LMS_TRAINING_STATUSES_ERROR_CSS:
    case types.UPDATING_LMS_TRAINING_PATH_ERROR:
    case types.ADD_LMS_TRAINING_PATH_ERROR:
    case types.FETCHING_LMS_CHILD_MODULE_STATUSES_ERROR: {
      const error =
        typeof action.error === 'string'
          ? new Error(action.error)
          : action.error
      console.error(typeof action.error, action.error, error)

      return {
        ...state,
        error: error,
        isFetching: false,
      }
    }

    case types.FETCHING_LMS_TRAINING_STATUSES_SUCCESS_CSS: {
      return {
        ...state,
        ...action.status,
        isFetching: false,
        error: null,
      }
    }

    case types.UPDATING_LMS_TRAINING_PATH_SUCCESS:
    case types.ADD_LMS_TRAINING_PATH_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        error: null,
        status: action.status,
      }
    }

    case types.SET_ACTIVE_SKU_CODE: {
      return {
        ...state,
        activeSkuCode: action.skuCode,
      }
    }

    case types.IS_SAVING_TRAINING: {
      return {
        ...state,
        isSavingTraining: action.saving,
      }
    }

    case types.FETCHING_LMS_CHILD_MODULE_STATUSES_SUCCESS: {
      return {
        ...state,
        childModuleProgress: Object.assign({}, state.childModuleProgress, {
          [action.program]: action.moduleFilter,
        }),
        isFetching: false,
        error: null,
      }
    }

    case types.CLEAR_LMS_CHILD_MODULE_STATUSES: {
      let newChildModuleProgress
      if (!action.program) {
        newChildModuleProgress = initialState.childModuleProgress
      } else {
        newChildModuleProgress = Object.assign({}, state.childModuleProgress, {
          [action.program]: [],
        })
      }
      return {
        ...state,
        childModuleProgress: newChildModuleProgress,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/lmsManager/lmsManager.js